import type { ReactNode } from "react";

import ConexionSection from "./sections/ConexionSection";
import OperacionesSection from "./sections/OperacionesSection";
import AlertasSection from "./sections/AlertasSection";
import ContrapartesSection from "./sections/ContrapartesSection";
import SnapshotSection from "./sections/SnapshotSection";
import ConfiguracionSection from "./sections/ConfiguracionSection";

export interface RadarCorreoNavItem {
  id: string;
  labelKey: string;
  icon: string;
  element: ReactNode;
}

export const MENU: RadarCorreoNavItem[] = [
  { id: "conexion", labelKey: "menu.conexion", icon: "ri-mail-settings-line", element: <ConexionSection /> },
  { id: "operaciones", labelKey: "menu.operaciones", icon: "ri-ship-2-line", element: <OperacionesSection /> },
  { id: "alertas", labelKey: "menu.alertas", icon: "ri-alarm-warning-line", element: <AlertasSection /> },
  { id: "contrapartes", labelKey: "menu.contrapartes", icon: "ri-building-2-line", element: <ContrapartesSection /> },
  { id: "snapshot", labelKey: "menu.snapshot", icon: "ri-camera-lens-line", element: <SnapshotSection /> },
  { id: "configuracion", labelKey: "menu.configuracion", icon: "ri-settings-3-line", element: <ConfiguracionSection /> },
];

export const RADAR_CORREO_BASE = "/radar-correo";
export const radarCorreoDefaultRoute = `${RADAR_CORREO_BASE}/${MENU[0].id}`;

export const radarCorreoApp = {
  id: "radar-correo",
  iconClass: "ri-mail-star-line",
  color: "bg-teal-500",
  route: radarCorreoDefaultRoute,
};
